module.exports = __webpack_public_path__ + "img/3_การตรวจนับ.7d60f46e.png";